export default "__VITE_ASSET__B0Aar8OH__"